<template>
  <a class="FeaturedItem" v-bind="linkProps">
    <div class="media">
      <SanityImage v-if="content.image" :asset="content.image.asset" class="image" />
    </div>
    <div class="text">
      <div v-if="label" class="label">{{ label }}</div>
      <h3 class="title">{{ content.title }}</h3>
      <p v-if="includeDescription && content.description"
        class="description"
      >{{ content.description }}</p>
    </div>
  </a>
</template>

<script>
import strings from './strings.json'

export default {
  props: {
    content: Object,
    includeDescription: Boolean,
  },
  inject: ['locale'],
  computed: {
    label() {
      const localeStrings = strings[this.locale]
      return localeStrings?.featuredItemLabels[this.content._type]
    },
    linkProps() {
      return {
        href: this.content.urlOrPath,
        target: this.content.urlOrPath?.startsWith('http') ? '_blank' : '_self'
      }
    },
  },
}
</script>

<style scoped>

.FeaturedItem {
  display: grid;
  grid-template-columns: 2fr 3fr;
  column-gap: var(--spacing-6);
  align-items: start;
}

.media {
  border-radius: 5px;
  overflow: hidden;
}

.image {
  width: 100%;
  height: 5rem;
  object-fit: cover;
}

.label {
  font-size: var(--font-size-1);
  font-weight: 500;
  line-height: 1;
  text-transform: uppercase;
}

.title {
  font-size: var(--font-size-2);
  line-height: 1.4;
  color: var(--text-color-black);
}

.description {
  font-size: var(--font-size-1);
  font-weight: 400;
  line-height: 1.4;
}

.label, .description {
  color: #9CA3AB;
}

.label + .title {
  margin-top: 0.25rem;
}

.title + .description {
  margin-top: 0.25rem;
}

.featuredItemsPane {
  flex-basis: 40%;
  padding-top: var(--spacing-9);
  padding-right: var(--gutter-width);
  padding-bottom: var(--spacing-12);
  padding-left: var(--spacing-9);
  background-color: var(--bg-color-pale-gray);
  border-left: thin solid var(--hairline-color);
}

.featuredItems {
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-6);
}

@media (--screen-xl) {
  .image {
    height: 6rem;
  }
}
</style>
